import type { SiteEntity } from "src/app/features/Site/types/SiteEntity";
import type { SiteGroupEntity } from "src/app/features/SiteGroup/types/SiteGroupEntity";
import { deepClone } from "../../../core/utils/utilFunctions";

export const updateWatchedFieldsUtils = (siteGroup: SiteGroupEntity | null, formData: SiteEntity | SiteGroupEntity) => {
    const newFormData = deepClone(formData);

    const updateFields = [
        "terminalParameters.headerLines",
        "terminalParameters.footerLines",
        "terminalParameters.posFooter",
        "terminalParameters.eventLog",
        "terminalParameters.tankLimit",
        "terminalParameters.nonstop",
        "guiProfile",
        "guiWelcomeText",
        "acousticNotification",
        "acousticNotificationOfTransactionResult",
        "logPosCommunication",
        "promptForDebit",
    ];

    if (siteGroup) {
        updateFields?.forEach((fieldName: string) => {
            newFormData[fieldName] = siteGroup[fieldName as keyof SiteGroupEntity];
        });
        // productProfileId is inherited from the parent's childProductProfileId
        newFormData.productProfileId = siteGroup.childProductProfileId;
    }

    // HANDLE DYNAMIC PROPERTIES
    const dynamicPropertiesList = siteGroup?.dynamicProperties?.dynamicPropertyValues || [];
    newFormData.dynamicProperties = {
        dynamicPropertyGroupValue: siteGroup?.dynamicProperties?.dynamicPropertyGroupValue,
        dynamicPropertyValues: dynamicPropertiesList.map(({ id: _id, ...rest }) => {
            return {
                id: _id,
                ...rest,
            };
        }),
    };

    newFormData.dynamicPropertiesCheckReadOnly = !!siteGroup;

    return newFormData;
};
